import * as yup from 'yup';
import { confirmPassword, password, TranslateFn } from '../../../library/validationRules';

/**
 * Empty when no password is needed. An account that already has one is joining a second
 * clinic rather than being created, and the API refuses a password it did not ask for --
 * an invitation must never become a way to reset somebody's password.
 */
export const createAcceptInvitationSchema = (
    translate: TranslateFn,
    passwordRequired: boolean
) => passwordRequired
    ? yup.object({
        // PASSWORD_MIN on the rule mirrors AcceptInvitationRequest.@Size(min = 6).
        password: password(translate),
        confirmPassword: confirmPassword(translate, 'password'),
    })
    : yup.object({
        password: yup.string().defined(),
        confirmPassword: yup.string().defined(),
    });
